import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  // DropdownTreeSelect,
  Common,
  DateTimePickerComponent,
  Spinner,
  ReactTags
} from '../../config/react'

import CheckboxTree from 'react-checkbox-tree'
const AddCatalogPriceRule = () => {
  const urlParams = useParams()
  const history = useHistory()
  const validator = useRef(new SimpleReactValidator())
  const submitbtnRef = useRef()
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [Categories, setCategories] = useState([])
  const [ExcludeCategories, setExcludeCategories] = useState([])
  const [SelectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [SelectedExcludeCategoryIds, setSelectedExcludeCategoryIds] = useState([])
  const [Products, setProducts] = useState([])
  const [ExcludeProducts, setExcludeProducts] = useState([])
  const [SelectedProductsIds, setSelectedProductsIds] = useState([])

  const [ProductTags, setProductTags] = useState([])
  const [ExcludeProductTags, setExcludeProductTags] = useState([])
  const [SelectedExcludeProductsIds, setSelectedExcludeProductsIds] = useState([])
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  // const today = new Date().toISOString().split('T')[0]
  const [Inputs, setInputs] = useState({
    id: 0,
    rule_name: '',
    description: '',
    discount_type: 'percentage',
    discount_percentage: 0,
    discount_amount: 0,
    start_date: '',
    end_date: '',
    status: 0
  })

  const [filterText, setFilterText] = useState('')
  const [filterTextExcludeCategory, setFilterTextExcludeCategory] = useState('')
  const [CategoryExpanded, setCategoryExpanded] = useState([])
  const [ExcludeCategoryExpanded, setExcludeCategoryExpanded] = useState([])
  const [CategoryClick, setCategoryClick] = useState(false)
  const [ExcludeCategoryClick, setExcludeCategoryClick] = useState(false)

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.AddCatalogPriceRule
    if (urlParams.id !== undefined) {
      document.title = Title.EditCatalogPriceRule
      GetCatalogPriceRuleDetail()
    } else {
      GetCategories()
      // GetProductLists()
    }
  }, [urlParams.id])

  const onCheck = (checkedValues) => {
    // setSelectedCategoryIds((prevSelectedCategoryIds) => ({
    //   ...prevSelectedCategoryIds,
    //   checkedValues
    // }))
    if (SelectedCategoryIds.length > 0) SelectedCategoryIds.map((item) => checkedValues.push(item))
    setSelectedCategoryIds((prevSelectedCategoryIds) => {
      let updatedSelectedCategoryIds = [...prevSelectedCategoryIds]
      checkedValues.forEach((value) => {
        if (updatedSelectedCategoryIds.includes(value)) {
          updatedSelectedCategoryIds = updatedSelectedCategoryIds.filter((id) => id !== value)
        } else {
          updatedSelectedCategoryIds.push(value)
        }
      })

      return updatedSelectedCategoryIds
    })
  }
  const onCheckExcludeCategory = (checkedValues) => {
    // setSelectedCategoryIds((prevSelectedCategoryIds) => ({
    //   ...prevSelectedCategoryIds,
    //   checkedValues
    // }))
    if (SelectedExcludeCategoryIds.length > 0)
      SelectedExcludeCategoryIds.map((item) => checkedValues.push(item))
    setSelectedExcludeCategoryIds((prevSelectedExcludeCategoryIds) => {
      let updatedSelectedExcludeCategoryIds = [...prevSelectedExcludeCategoryIds]
      checkedValues.forEach((value) => {
        if (updatedSelectedExcludeCategoryIds.includes(value)) {
          updatedSelectedExcludeCategoryIds = updatedSelectedExcludeCategoryIds.filter(
            (id) => id !== value
          )
        } else {
          updatedSelectedExcludeCategoryIds.push(value)
        }
      })

      return updatedSelectedExcludeCategoryIds
    })
  }

  const handleClick = () => {
    CategoryClick
      ? setCategoryClick('')
      : setCategoryClick('text-left form-control custom-select show')
  }
  const handleClickExcludeCategory = () => {
    ExcludeCategoryClick
      ? setExcludeCategoryClick('')
      : setExcludeCategoryClick('text-left form-control custom-select show')
  }

  const onExpand = (value) => {
    setCategoryExpanded(value)
  }
  const onExpandExcludeCategory = (value) => {
    setExcludeCategoryExpanded(value)
  }

  const onFilterChange = (e) => {
    setFilterText(e.target.value.toLowerCase())
  }
  const onFilterChangeExcludecategory = (e) => {
    setFilterTextExcludeCategory(e.target.value.toLowerCase())
    // setFilterText(e.target.value.toLowerCase())
  }

  const ExcludeCategoryfilterNodes = (nodes, searchText) => {
    const loweredSearchText = searchText.toLowerCase()
    return nodes
      .map((node) => {
        const isNodeMatching = node.label.toLowerCase().includes(loweredSearchText)
        let filteredChildren = null
        if (node.children) {
          filteredChildren = ExcludeCategoryfilterNodes(node.children, loweredSearchText)
        }
        if (isNodeMatching || (filteredChildren !== null && filteredChildren.length > 0)) {
          return {
            ...node,
            children: filteredChildren
          }
        }
        return null
      })
      .filter((node) => node !== null)
  }
  const filteredExcludeCategories = ExcludeCategoryfilterNodes(
    ExcludeCategories,
    filterTextExcludeCategory
  )

  const filterNodes = (nodes, searchText) => {
    const loweredSearchText = searchText.toLowerCase()
    return nodes
      .map((node) => {
        const isNodeMatching = node.label.toLowerCase().includes(loweredSearchText)
        let filteredChildren = null
        if (node.children) {
          filteredChildren = filterNodes(node.children, loweredSearchText)
        }
        if (isNodeMatching || (filteredChildren !== null && filteredChildren.length > 0)) {
          return {
            ...node,
            children: filteredChildren
          }
        }
        return null
      })
      .filter((node) => node !== null)
  }
  const filteredCategories = filterNodes(Categories, filterText)

  const onChangeProduct = (value) => {
    if (value.trim().length < 3) return setProducts()
    new Promise((resolve) => {
      const param = {
        term: value
      }
      HttpService.postApi(API.SearchProducts, param).then((response) => {
        let products = []
        if (response.data.result.length > 0) {
          products = response.data.result.map((item) => ({
            value: item.id,
            label: item.name + ' - ' + item.sku
          }))
        } else products = []
        setProducts(products)
        setForceUpdate(!isForceUpdate)
        resolve(products)
      })
    })
  }
  const onChangeExcludeProduct = (value) => {
    if (value.trim().length < 3) return setExcludeProducts()
    new Promise((resolve) => {
      const param = {
        term: value
      }
      HttpService.postApi(API.SearchProducts, param).then((response) => {
        let products = []
        if (response.data.result.length > 0) {
          products = response.data.result.map((item) => ({
            value: item.id,
            label: item.name + ' - ' + item.sku
          }))
        } else products = []
        setExcludeProducts(products)
        setForceUpdate(!isForceUpdate)
        resolve(products)
      })
    })
  }
  const onDeleteProduct = (i) => {
    const newTags = ProductTags.slice(0)
    newTags.splice(i, 1)
    setProductTags(newTags)
    setSelectedProductsIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const onDeleteExcludeProduct = (i) => {
    const newTags = ExcludeProductTags.slice(0)
    newTags.splice(i, 1)
    setExcludeProductTags(newTags)
    setSelectedExcludeProductsIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const onSelectProduct = (tag) => {
    const newTags = [...ProductTags, tag]
    setProductTags(newTags)
    setSelectedProductsIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const onSelectExcludeProduct = (tag) => {
    const newTags = [...ExcludeProductTags, tag]
    setExcludeProductTags(newTags)
    setSelectedExcludeProductsIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const GetCategories = (selectedCategory = null, selectedExcludeCategory = null) => {
    setLoading(true)
    HttpService.postApi(API.GetCategory, null).then((response) => {
      setLoading(false)
      if (response.data.result) {
        // filter parent category
        response.data.result[0] = response.data.result[0].filter((item) => item.status === 1)
        const parentCategories = response.data.result[0].filter((x) => x.parent_id === 1)
        const categories = []
        const excludeCategories = []
        parentCategories.map((item) => {
          // filter sub categories by parent
          const filteredSubcategories = response.data.result[0].filter(
            (x) => x.parent_id === item.id
          )
          const subcategories = []
          filteredSubcategories.map((subitem) => {
            // filter sub child categories by parent
            const filteredSubChildCategories = response.data.result[0].filter(
              (x) => x.parent_id === subitem.id
            )
            const subchildcategories = []
            filteredSubChildCategories.map((childitem) => {
              subchildcategories.push({
                label: childitem.name,
                value: childitem.id,
                checked: false,
                children: []
              })
              return true
            })
            subcategories.push({
              label: subitem.name,
              value: subitem.id,
              checked: false,
              children: subchildcategories
            })
            return true
          })
          const subcategories1 = []
          filteredSubcategories.map((subitem) => {
            // filter sub child categories by parent
            const filteredSubChildCategories = response.data.result[0].filter(
              (x) => x.parent_id === subitem.id
            )
            const subchildcategories1 = []
            filteredSubChildCategories.map((childitem) => {
              subchildcategories1.push({
                label: childitem.name,
                value: childitem.id,
                checked: false,
                children: []
              })
              return true
            })
            subcategories1.push({
              label: subitem.name,
              value: subitem.id,
              checked: false,
              children: subchildcategories1
            })
            return true
          })
          categories.push({
            label: item.name,
            value: item.id,
            children: subcategories,
            checked: false
          })
          excludeCategories.push({
            label: item.name,
            value: item.id,
            children: subcategories1,
            checked: false
          })
          return true
        })
        if (selectedCategory !== null) {
          for (var i = 0; i < categories.length; i++) {
            selectedCategory.map((cate) => {
              if (cate === categories[i].value) {
                categories[i].checked = true
              }
              return true
            })
            var children = categories[i].children
            if (children.length > 0) {
              for (var j = 0; j < children.length; j++) {
                selectedCategory.map((cate1) => {
                  if (cate1 === children[j].value) {
                    children[j].checked = true
                  }
                  return true
                })
                var children1 = children[j].children
                if (children1.length > 0) {
                  for (var k = 0; k < children1.length; k++) {
                    selectedCategory.map((cate2) => {
                      if (cate2 === children1[k].value) {
                        children1[k].checked = true
                      }
                      return true
                    })
                  }
                }
              }
            }
          }
        }
        setCategories(categories)
        if (selectedExcludeCategory !== null) {
          for (i = 0; i < categories.length; i++) {
            selectedExcludeCategory.map((cate) => {
              if (cate === excludeCategories[i].value) {
                excludeCategories[i].checked = true
              }
              return true
            })
            children = excludeCategories[i].children
            if (children.length > 0) {
              for (j = 0; j < children.length; j++) {
                selectedExcludeCategory.map((cate1) => {
                  if (cate1 === children[j].value) {
                    children[j].checked = true
                  }
                  return true
                })
                children1 = children[j].children
                if (children1.length > 0) {
                  for (k = 0; k < children1.length; k++) {
                    selectedExcludeCategory.map((cate2) => {
                      if (cate2 === children1[k].value) {
                        children1[k].checked = true
                      }
                      return true
                    })
                  }
                }
              }
            }
          }
        }
        setExcludeCategories(excludeCategories)
      }
    })
  }
  // const onChangeCategory = (currentNode, selectedNodes) => {
  //   const array = []
  //   if (selectedNodes.length > 0) {
  //     for (let i = 0; i < selectedNodes.length; i++) {
  //       array.push(selectedNodes[i].value)
  //     }
  //   }

  //   setSelectedCategoryIds(array)
  //   setForceUpdate(!isForceUpdate)
  //   console.log(array)
  //   Categories.map((item, index) => {
  //     if (array.indexOf(item.value) >= 0) {
  //       Categories[index].checked = true
  //     } else {
  //       Categories[index].checked = false
  //     }
  //     item.children.map((subitem, subindex) => {
  //       if (array.indexOf(subitem.value) >= 0) {
  //         Categories[index].children[subindex].checked = true
  //       } else {
  //         Categories[index].children[subindex].checked = false
  //       }
  //       subitem.children.map((subitem1, subindex1) => {
  //         if (array.indexOf(subitem1.value) >= 0) {
  //           Categories[index].children[subindex].children[subindex1].checked = true
  //         } else {
  //           Categories[index].children[subindex].children[subindex1].checked = false
  //         }
  //         return true
  //       })
  //       return true
  //     })
  //     return true
  //   })
  // }
  // const onChangeExcludeCategory = (currentNode, selectedNodes) => {
  //   const array = []
  //   if (selectedNodes.length > 0) {
  //     for (let i = 0; i < selectedNodes.length; i++) {
  //       array.push(selectedNodes[i].value)
  //     }
  //   }
  //   setSelectedExcludeCategoryIds(array)
  //   setForceUpdate(!isForceUpdate)
  //   ExcludeCategories.map((item, index) => {
  //     if (array.indexOf(item.value) >= 0) {
  //       ExcludeCategories[index].checked = true
  //     } else {
  //       ExcludeCategories[index].checked = false
  //     }
  //     item.children.map((subitem, subindex) => {
  //       if (array.indexOf(subitem.value) >= 0) {
  //         ExcludeCategories[index].children[subindex].checked = true
  //       } else {
  //         ExcludeCategories[index].children[subindex].checked = false
  //       }
  //       subitem.children.map((subitem1, subindex1) => {
  //         if (array.indexOf(subitem1.value) >= 0) {
  //           ExcludeCategories[index].children[subindex].children[subindex1].checked = true
  //         } else {
  //           ExcludeCategories[index].children[subindex].children[subindex1].checked = false
  //         }
  //         return true
  //       })
  //       return true
  //     })
  //     return true
  //   })
  // }
  const handleInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value

    if (field === 'status') Inputs[field] = e.target.checked
    else Inputs[field] = fieldval
    setForceUpdate(!isForceUpdate)

    if (field === 'percentage') {
      validator.current.hideMessageFor('discount_amount')
    } else if (field === 'fixed_amount') {
      validator.current.hideMessageFor('discount_percentage')
    }
  }
  const SubmitForm = (e) => {
    if (Inputs.discount_type !== 'percentage') {
      validator.current.errorMessages['Discount Percentage'] = null
      validator.current.fields['Discount Percentage'] = true
    }
    if (Inputs.discount_type !== 'fixed_amount') {
      validator.current.errorMessages['Discount Amount'] = null
      validator.current.fields['Discount Amount'] = true
    }

    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    const sDate = new Date(Inputs.start_date)
    const eDate = new Date(Inputs.end_date)
    const seconds = (eDate.getTime() - sDate.getTime()) / 1000
    if (eDate < sDate) {
      toast.warning(Messages.smalldate)
      return
    }
    if (seconds < 3600) {
      toast.warning(Messages.samedate)
      return
    }

    if (submitbtnRef.current) submitbtnRef.current.setAttribute('disabled', 'disabled')

    const param = {
      id: Inputs.id,
      rule_name: Inputs.rule_name,
      description: Inputs.description,
      discount_type: Inputs.discount_type,
      discount_amount:
        Inputs.discount_type !== 'fixed_amount'
          ? 0
          : Inputs.discount_amount === ''
            ? 0
            : parseInt(Inputs.discount_amount),
      discount_percentage:
        Inputs.discount_type !== 'percentage'
          ? 0
          : Inputs.discount_percentage === ''
            ? 0
            : parseInt(Inputs.discount_percentage),
      // start_date: Inputs.start_date
      //   ? Moment.tz(Inputs.start_date, 'America/Halifax').utc().format('YYYY-MM-DD HH:mm:ss')
      //   : null,

      // end_date: Inputs.end_date
      //   ? Moment.tz(Inputs.end_date, 'America/Halifax').utc().format('YYYY-MM-DD HH:mm:ss')
      //   : null,
      start_date: Inputs.start_date ? Inputs.start_date : null,
      end_date: Inputs.end_date ? Inputs.end_date : null,
      category_ids:
        SelectedProductsIds.length > 0 || SelectedExcludeProductsIds.length > 0
          ? []
          : SelectedCategoryIds,
      exclude_category_ids:
        SelectedProductsIds.length > 0 || SelectedExcludeProductsIds.length > 0
          ? []
          : SelectedExcludeCategoryIds,
      product_ids:
        SelectedCategoryIds.length > 0 || SelectedExcludeCategoryIds.length > 0
          ? []
          : JSON.stringify(SelectedProductsIds),
      exclude_product_ids:
        SelectedCategoryIds.length > 0 || SelectedExcludeCategoryIds.length > 0
          ? []
          : JSON.stringify(SelectedExcludeProductsIds),
      status: Inputs.status ? 1 : 0,
      Userid: user.id
    }
    if (Inputs.discount_type === 'percentage') {
      param.discount_amount = 0
    } else {
      param.discount_percentage = 0
    }
    if (urlParams.id === undefined) {
      setLoading(true)
      HttpService.postApi(API.AddCatalogPriceRule, param).then((response) => {
        setLoading(false)
        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          submitbtnRef.current.removeAttribute('disabled')
          return
        }
        toast.success(Messages.RecordAdded)
        setForceUpdate(!isForceUpdate)
        history.push('/marketing/catalog-price-rule')
      })
    } else {
      setLoading(true)
      HttpService.postApi(API.UpdateCatalogPriceRule, param).then((response) => {
        setLoading(false)
        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          submitbtnRef.current.removeAttribute('disabled')
          return
        }
        toast.success(Messages.RecordUpdated)
        setForceUpdate(!isForceUpdate)
        history.push('/marketing/catalog-price-rule')
      })
    }
  }
  const GetCatalogPriceRuleDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetCatalogPriceRuleDetail, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const data = response.data.result[0][0]

        const responseData = {
          id: data.id,
          rule_name: data.rule_name,
          description: data.description,
          start_date: data.start_date,
          end_date: data.end_date,
          discount_type: data.discount_type,
          discount_amount: data.discount_amount,
          discount_percentage: data.discount_percentage,
          status: data.status
        }
        // if (responseData.start_date !== '') {
        //   var date = Moment(responseData.start_date).format('YYYY-MM-DD')
        //   date = date + 'T' + Moment(responseData.start_date).format('HH:mm')
        //   responseData.start_date = date
        // }
        if (responseData.start_date !== '') {
          var sdate = responseData.start_date.slice(0, 16)
          responseData.start_date = sdate
        }
        if (responseData.end_date !== '') {
          var edate = responseData.end_date.slice(0, 16)
          responseData.end_date = edate
        }
        // if (responseData.end_date !== '') {
        //   date = Moment(responseData.end_date).format('YYYY-MM-DD')
        //   date = date + 'T' + Moment(responseData.end_date).format('HH:mm')
        //   responseData.end_date = date
        // }
        setInputs(responseData)
        setForceUpdate(!isForceUpdate)
        setSelectedCategoryIds(data.category_ids.length > 0 ? data.category_ids : [])
        setSelectedExcludeCategoryIds(
          data.exclude_categories !== null && data.exclude_categories.length > 0
            ? data.exclude_categories
            : []
        )
        setSelectedProductsIds(
          data.product_ids !== null && data.product_ids.length > 0
            ? Common.GetJSON(data.product_ids)
            : []
        )
        setProductTags(
          data.product_ids !== null && data.product_ids.length > 0 ? data.products : []
        )
        setSelectedExcludeProductsIds(
          data.exclude_product_ids !== null && data.exclude_product_ids.length > 0
            ? Common.GetJSON(data.exclude_product_ids)
            : []
        )
        setExcludeProductTags(
          data.exclude_product_ids !== null && data.exclude_product_ids.length > 0
            ? data.exclude_products
            : []
        )
        GetCategories(Common.GetJSON(data.category_ids), Common.GetJSON(data.exclude_categories))
        // GetProductLists(Common.GetJSON(data.product_ids), Common.GetJSON(data.exclude_products))
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  const preventMinus = (e) => {
    if (e.code === 'Minus' || e.code === 'NumpadSubtract') {
      e.preventDefault()
    }
  }

  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined ? Title.EditCatalogPriceRule : Title.AddCatalogPriceRule}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Rule Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="rule_name"
                        onChange={handleInputChanges}
                        value={Inputs.rule_name}
                        placeholder="Rule Name"
                      />
                      {validator.current.message(
                        'Rule Name',
                        Inputs.rule_name,
                        'required|max:255',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        onChange={handleInputChanges}
                        value={Inputs.description}
                        placeholder="Description"
                        rows="2"
                      ></textarea>
                      {validator.current.message('Description', Inputs.description, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Discount Type</label>
                      <select
                        className="form-control"
                        name="discount_type"
                        onChange={handleInputChanges}
                        value={Inputs.discount_type}
                      >
                        <option value="percentage">Percentage</option>
                        <option value="fixed_amount">Fixed Amount</option>
                      </select>
                      {validator.current.message(
                        'Discount Type',
                        Inputs.discount_type,
                        'required',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                  {Inputs.discount_type === 'percentage' ? (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Percentage</label>
                        <input
                          type="number"
                          min="0"
                          className="form-control"
                          name="discount_percentage"
                          onChange={handleInputChanges}
                          value={Inputs.discount_percentage}
                          placeholder="Discount Percentage"
                          onKeyPress={preventMinus}
                        />
                        {validator.current.message(
                          'Discount Percentage',
                          Inputs.discount_percentage,
                          'required|numeric|max:99,num|min:0,num',
                          { className: 'error' }
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {Inputs.discount_type === 'fixed_amount' ? (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Amount</label>
                        <input
                          onKeyPress={preventMinus}
                          type="number"
                          className="form-control"
                          name="discount_amount"
                          onChange={handleInputChanges}
                          value={Inputs.discount_amount}
                          placeholder="Discount Amount"
                          min="0"
                        />
                        {validator.current.message(
                          'Discount Amount',
                          Inputs.discount_amount,
                          'required|numeric|min:0,num',
                          { className: 'error' }
                        )}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Start Date </label>
                      <DateTimePickerComponent
                        name="start_date"
                        value={Inputs.start_date ? new Date(Inputs.start_date) : null}
                        format="dd/MM/yyyy hh:mm a"
                        change={(e) => {
                          setInputs({
                            ...Inputs,
                            start_date: e.value ? e.value.toISOString() : ''
                          })
                        }}
                        min={new Date()}
                      />
                      {/* <input
                        type="datetime-local"
                        className="form-control"
                        name="start_date"
                        onChange={handleInputChanges}
                        value={Inputs.start_date}
                        placeholder="Start Date"
                        min={new Date()}
                      /> */}
                      {validator.current.message('Start Date', Inputs.start_date, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>End Date</label>
                      <DateTimePickerComponent
                        name="end_date"
                        value={Inputs.end_date ? new Date(Inputs.end_date) : null}
                        format="dd/MM/yyyy hh:mm a"
                        change={(e) => {
                          setInputs({
                            ...Inputs,
                            end_date: e.value ? e.value.toISOString() : ''
                          })
                        }}
                        min={new Date()}
                      />
                      {/* <input
                        type="datetime-local"
                        className="form-control"
                        name="end_date"
                        onChange={handleInputChanges}
                        value={Inputs.end_date}
                        placeholder="End Date"
                        min={new Date()}
                      /> */}
                      {validator.current.message('End Date', Inputs.end_date, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div
                        className={
                          SelectedCategoryIds?.length > 0 || SelectedExcludeCategoryIds?.length > 0
                            ? 'col-md-6 d-none'
                            : 'col-md-6'
                        }
                      >
                        <div className="form-group">
                          <label>Products</label>
                          <ReactTags
                            selected={ProductTags}
                            suggestions={Products}
                            onDelete={onDeleteProduct}
                            onAdd={onSelectProduct}
                            onInput={onChangeProduct}
                            placeholderText="Choose..."
                          />
                        </div>
                      </div>
                      <div
                        className={
                          SelectedCategoryIds?.length > 0 || SelectedExcludeCategoryIds?.length > 0
                            ? 'col-md-6 d-none'
                            : 'col-md-6'
                        }
                      >
                        <div className="form-group">
                          <label>Exclude Products</label>
                          <ReactTags
                            selected={ExcludeProductTags}
                            suggestions={ExcludeProducts}
                            onDelete={onDeleteExcludeProduct}
                            onAdd={onSelectExcludeProduct}
                            onInput={onChangeExcludeProduct}
                            placeholderText="Choose..."
                          />
                        </div>
                      </div>
                      {/* <div
                        className={
                          SelectedProductsIds?.length > 0 || SelectedExcludeProductsIds?.length > 0
                            ? 'col-md-6 d-none'
                            : 'col-md-6'
                        }
                      >
                        <div className="form-group">
                          <label>Category</label>
                          {Categories.length > 0 && (
                            <DropdownTreeSelect
                              data={Categories}
                              id="categorySelect"
                              mode="multiSelect"
                              keepOpenOnSelect="true"
                              onChange={onChangeCategory}
                              className="bootstrap-demo"
                            />
                          )}
                        </div>
                      </div> */}
                      <div
                        className={
                          SelectedProductsIds?.length > 0 || SelectedExcludeProductsIds?.length > 0
                            ? 'col-md-6 d-none'
                            : 'col-md-6'
                        }
                      >
                        <label>Category</label>
                        <div className="custom-dropdown text-left">
                          <button
                            type="button"
                            className={CategoryClick || 'text-left form-control custom-select'}
                            onClick={handleClick}
                          >
                            Select Category
                          </button>
                          <div className="dropdown-menu mt-4">
                            <input
                              className="form-control m-1"
                              placeholder="Search..."
                              type="text"
                              // value={filterText}
                              onChange={onFilterChange}
                            />
                            <CheckboxTree
                              checked={SelectedCategoryIds}
                              expandOnClick
                              expanded={CategoryExpanded}
                              nodes={filteredCategories}
                              onCheck={onCheck}
                              onExpand={onExpand}
                              icons={{
                                parentClose: null, // Hides the folder icon for closed parent nodes
                                parentOpen: null, // Hides the folder icon for opened parent nodes
                                leaf: null
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div
                        className={
                          SelectedProductsIds?.length > 0 || SelectedExcludeProductsIds?.length > 0
                            ? 'col-md-6 d-none'
                            : 'col-md-6'
                        }
                      >
                        <div className="form-group">
                          <label>Exclude Category</label>
                          {ExcludeCategories.length > 0 && (
                            <DropdownTreeSelect
                              data={ExcludeCategories}
                              id="excludeCategorySelect"
                              mode="hierarchical"
                              onChange={onChangeExcludeCategory}
                              className="bootstrap-demo w-100"
                            />
                          )}
                        </div>
                      </div> */}
                      <div
                        className={
                          SelectedProductsIds?.length > 0 || SelectedExcludeProductsIds?.length > 0
                            ? 'col-md-6 d-none'
                            : 'col-md-6'
                        }
                      >
                        <label>Exclude Category</label>
                        <div className="custom-dropdown text-left">
                          <button
                            type="button"
                            className={
                              ExcludeCategoryClick || 'text-left form-control custom-select'
                            }
                            onClick={handleClickExcludeCategory}
                          >
                            Select Category
                          </button>
                          <div className="dropdown-menu mt-4">
                            <input
                              className="form-control m-1"
                              placeholder="Search..."
                              type="text"
                              // value={filterText}
                              onChange={onFilterChangeExcludecategory}
                            />
                            <CheckboxTree
                              checked={SelectedExcludeCategoryIds}
                              expandOnClick
                              expanded={ExcludeCategoryExpanded}
                              nodes={filteredExcludeCategories}
                              onCheck={onCheckExcludeCategory}
                              onExpand={onExpandExcludeCategory}
                              icons={{
                                parentClose: null, // Hides the folder icon for closed parent nodes
                                parentOpen: null, // Hides the folder icon for opened parent nodes
                                leaf: null
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mt-4">
                    <button
                      ref={submitbtnRef}
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/marketing/catalog-price-rule"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddCatalogPriceRule
